var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sign-in-button__icon",
    viewBox: "0 0 225 225",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.978,26.227C189.322,25.904 189.723,25.629 190.175,25.421C192.43,24.379 195.106,25.364 196.147,27.619L206.273,49.541C206.733,50.537 206.813,51.667 206.499,52.718L189.611,109.133L201.512,146.583L189.917,185.659L149.31,174.186L127.455,191.776L98.307,191.961L75.308,174.293L35.584,185.623L23.967,146.95L35.471,109.499L18.799,53.802C18.484,52.75 18.564,51.62 19.024,50.624L29.15,28.702C30.192,26.448 32.868,25.463 35.122,26.504C35.645,26.746 36.099,27.075 36.476,27.466L88.256,45.899L138.338,46.051L188.978,26.227ZM101.002,161.502L98.416,177.133L127.42,177.162L125.159,161.295L101.002,161.502ZM134.473,120.632L124.719,139.859L156.531,131.232L134.473,120.632ZM90.887,121.272L100.231,139.69L69.757,131.426L90.887,121.272ZM27.909,52.852L35.695,35.995L99.222,75.26L74.409,96.951L43.669,105.502L27.909,52.852ZM189.418,34.513L197.388,51.769L181.31,105.48L150.71,96.683L126.42,75.724L189.418,34.513Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.0ce55757.svg";
export { ForwardRef as ReactComponent };